import { createSelector } from 'reselect'

import type { IAttentionOwnerAssignment } from '../../lib'

import { selectCockpitPbmUsers } from './selectCockpitPbmUsers'

/**
 * Who owns each partner, for the attention tile's PBM grouping. The users behind it are already
 * scoped to the selected offering, so switching offering regroups the drill-down the same way it
 * rescopes the statuses above it.
 */
export const selectCockpitAttentionPbmAssignments = createSelector(
  [selectCockpitPbmUsers],
  (pbmUsers): IAttentionOwnerAssignment[] =>
    pbmUsers.map(({ PartnerId, Email, FullName }) => ({
      partnerId: PartnerId,
      ownerId: Email,
      /* The payload leaves the name out for a user it only knows by their account. */
      ownerName: FullName || Email,
    }))
)
